(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["land-buying-guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-land-js="land-buying"]');
    if (!root) return;
    var els = root.querySelectorAll('[data-land-reveal]');
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('land-in'); });
      root.classList.add('land-drawn');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('land-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { io.observe(el); });

    // Divider line sweep
    var lineIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('land-drawn'); lineIo.unobserve(en.target); }
      });
    }, { threshold: 0 });
    lineIo.observe(root);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["land-craft"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-land-js="land-craft"]');
    if (!root) return;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isDesktop = window.matchMedia('(min-width: 769px)').matches;
    var saveData = !!(navigator.connection && navigator.connection.saveData);

    // Workshop video — ambient muted loop on ALL devices (same file as desktop,
    // per user). Plays only when in view. Data-saver / reduced-motion get the
    // poster still and never download video.
    var vid = root.querySelector('video[data-src]');
    if (vid) {
      if (!saveData && !reduceMotion) {
        var vsrc = document.createElement('source');
        vsrc.src = vid.getAttribute('data-src');
        vsrc.type = 'video/mp4';
        vid.appendChild(vsrc);
        vid.load();
        if ('IntersectionObserver' in window) {
          var playIo = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) {
              if (en.isIntersecting) {
                var p = vid.play();
                if (p && p.catch) p.catch(function () {});
              } else {
                vid.pause();
              }
            });
          }, { threshold: 0.25 });
          playIo.observe(vid);
        }
      } else {
        root.classList.add('land-craft--no-video');
      }
    }

    var els = root.querySelectorAll('[data-land-reveal]');
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('land-in'); });
      root.classList.add('land-drawn');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('land-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.2 });
    els.forEach(function (el) { io.observe(el); });

    // Divider line sweep
    var lineIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('land-drawn'); lineIo.unobserve(en.target); }
      });
    }, { threshold: 0 });
    lineIo.observe(root);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["land-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-land-js="land-cta"]');
    if (!root) return;
    var els = root.querySelectorAll('[data-land-reveal]');
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('land-in'); });
      root.classList.add('land-drawn');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('land-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.25 });
    els.forEach(function (el) { io.observe(el); });

    // Divider line sweep
    var lineIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('land-drawn'); lineIo.unobserve(en.target); }
      });
    }, { threshold: 0 });
    lineIo.observe(root);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["land-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-land-js="land-faq"]');
    if (!root) return;
    var els = root.querySelectorAll('[data-land-reveal]');
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('land-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('land-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.2 });
    els.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["land-hero-patched"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var hero = document.querySelector('.land-hero');
    if (!hero) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isDesktop = window.matchMedia('(min-width: 769px)').matches;
    var saveData = !!(navigator.connection && navigator.connection.saveData);

    // Video: desktop gets the landscape file; mobile gets the portrait file if
    // set, else the still image. Data-saver / reduced-motion always get the still.
    // No <source> in markup, so nothing downloads until JS chooses.
    var vid = hero.querySelector('video[data-src]');
    if (vid) {
      var chosenSrc = null;
      if (!saveData && !reduce) {
        chosenSrc = isDesktop ? vid.getAttribute('data-src') : vid.getAttribute('data-src-mobile');
      }
      if (chosenSrc) {
        var src = document.createElement('source');
        src.src = chosenSrc;
        src.type = 'video/mp4';
        vid.appendChild(src);
        vid.load();
        var playAttempt = vid.play();
        if (playAttempt && playAttempt.catch) playAttempt.catch(function () {});
      } else {
        hero.classList.add('land-hero--no-video');
      }
    }

    // Scroll drift — content rises gently as you scroll past, but stays
    // fully opaque (per user: fade made the CTAs unreadable mid-scroll)
    if (!reduce) {
      var content = hero.querySelector('.land-hero__content');
      var hint = hero.querySelector('.land-hero__scroll');
      var scrollTicking = false;
      window.addEventListener('scroll', function () {
        if (scrollTicking) return;
        scrollTicking = true;
        requestAnimationFrame(function () {
          var h = hero.offsetHeight;
          var y = window.scrollY || window.pageYOffset;
          if (h > 0 && y < h) {
            var p = y / h;
            if (content) {
              content.style.opacity = '1';
              content.style.transform = 'translateY(' + (p * -32) + 'px)';
            }
            if (hint) hint.style.opacity = Math.max(0, 1 - p * 3);
          }
          scrollTicking = false;
        });
      }, { passive: true });
    }

    // Magnetic buttons — CTAs lean toward the cursor
    if (reduce) return;
    if (!window.matchMedia('(hover: hover)').matches) return;
    hero.querySelectorAll('[data-land-magnetic]').forEach(function (btn) {
      var strength = 6;
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) / (r.width / 2);
        var y = (e.clientY - r.top - r.height / 2) / (r.height / 2);
        btn.style.transform = 'translate(' + (x * strength) + 'px,' + (y * strength) + 'px)';
      });
      btn.addEventListener('mouseleave', function () {
        btn.style.transform = '';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["land-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var hero = document.querySelector('.land-hero');
    if (!hero) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isDesktop = window.matchMedia('(min-width: 769px)').matches;
    var saveData = !!(navigator.connection && navigator.connection.saveData);

    // Video: desktop gets the landscape file; mobile gets the portrait file if
    // set, else the still image. Data-saver / reduced-motion always get the still.
    // No <source> in markup, so nothing downloads until JS chooses.
    var vid = hero.querySelector('video[data-src]');
    if (vid) {
      var chosenSrc = null;
      if (!saveData && !reduce) {
        chosenSrc = isDesktop ? vid.getAttribute('data-src') : vid.getAttribute('data-src-mobile');
      }
      if (chosenSrc) {
        var src = document.createElement('source');
        src.src = chosenSrc;
        src.type = 'video/mp4';
        vid.appendChild(src);
        vid.load();
        var playAttempt = vid.play();
        if (playAttempt && playAttempt.catch) playAttempt.catch(function () {});
      } else {
        hero.classList.add('land-hero--no-video');
      }
    }

    // Scroll drift — content rises gently as you scroll past, but stays
    // fully opaque (per user: fade made the CTAs unreadable mid-scroll)
    if (!reduce) {
      var content = hero.querySelector('.land-hero__content');
      var hint = hero.querySelector('.land-hero__scroll');
      var scrollTicking = false;
      window.addEventListener('scroll', function () {
        if (scrollTicking) return;
        scrollTicking = true;
        requestAnimationFrame(function () {
          var h = hero.offsetHeight;
          var y = window.scrollY || window.pageYOffset;
          if (h > 0 && y < h) {
            var p = y / h;
            if (content) {
              content.style.opacity = '1';
              content.style.transform = 'translateY(' + (p * -32) + 'px)';
            }
            if (hint) hint.style.opacity = Math.max(0, 1 - p * 3);
          }
          scrollTicking = false;
        });
      }, { passive: true });
    }

    // Magnetic buttons — CTAs lean toward the cursor
    if (reduce) return;
    if (!window.matchMedia('(hover: hover)').matches) return;
    hero.querySelectorAll('[data-land-magnetic]').forEach(function (btn) {
      var strength = 6;
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) / (r.width / 2);
        var y = (e.clientY - r.top - r.height / 2) / (r.height / 2);
        btn.style.transform = 'translate(' + (x * strength) + 'px,' + (y * strength) + 'px)';
      });
      btn.addEventListener('mouseleave', function () {
        btn.style.transform = '';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["land-lineup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-land-js="land-lineup"]');
    if (!root) return;
    var els = root.querySelectorAll('[data-land-reveal]');
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('land-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('land-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["land-origin"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-land-js="land-origin"]');
    if (!root) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Reveal
    var els = root.querySelectorAll('[data-land-reveal], [data-land-parallax]');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('land-in'); });
      root.classList.add('land-drawn');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('land-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.2 });
    els.forEach(function (el) { io.observe(el); });

    // Divider line sweep
    var lineIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('land-drawn'); lineIo.unobserve(en.target); }
      });
    }, { threshold: 0 });
    lineIo.observe(root);

    // Gentle parallax on the image
    var media = root.querySelector('[data-land-parallax] img');
    if (!media) return;
    // Once the reveal transition finishes, kill it so parallax tracks instantly
    media.addEventListener('transitionend', function () {
      media.style.transition = 'none';
    }, { once: true });
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var rect = media.getBoundingClientRect();
        var vh = window.innerHeight;
        if (rect.bottom > 0 && rect.top < vh) {
          var progress = (rect.top + rect.height / 2 - vh / 2) / vh; // -0.5 .. 0.5
          media.style.transform = 'scale(1.05) translateY(' + (progress * -30) + 'px)';
        }
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["land-philosophy"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-land-js="land-philosophy"]');
    if (!root) return;
    var els = root.querySelectorAll('[data-land-reveal]');
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('land-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('land-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.2 });
    els.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["land-stats"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-land-js="land-stats"]');
    if (!root) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var items = root.querySelectorAll('[data-land-reveal]');

    // Odometer — each digit rolls up its own 0-9 strip, staggered left to right
    function odometer(el) {
      var text = el.getAttribute('data-land-value') || el.textContent;
      if (!/\d/.test(text) || reduce) return; // non-numeric (e.g. "Street legal") or reduced motion: leave as-is
      el.setAttribute('aria-label', text);
      el.innerHTML = '';
      text.split('').forEach(function (ch, idx) {
        if (/\d/.test(ch)) {
          var odo = document.createElement('span');
          odo.className = 'land-odo';
          odo.setAttribute('aria-hidden', 'true');
          var strip = document.createElement('span');
          strip.className = 'land-odo__strip';
          for (var d = 0; d <= 9; d++) {
            var s = document.createElement('span');
            s.textContent = d;
            strip.appendChild(s);
          }
          odo.appendChild(strip);
          el.appendChild(odo);
          (function (stripEl, digit, i) {
            setTimeout(function () {
              stripEl.style.transform = 'translateY(-' + digit + 'em)';
            }, 200 + i * 140);
          })(strip, parseInt(ch, 10), idx);
        } else {
          var plain = document.createElement('span');
          plain.textContent = ch;
          plain.setAttribute('aria-hidden', 'true');
          el.appendChild(plain);
        }
      });
    }

    if (!('IntersectionObserver' in window) || reduce) {
      items.forEach(function (el) { el.classList.add('land-in'); });
      root.classList.add('land-drawn');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('land-in');
        en.target.querySelectorAll('[data-land-value]').forEach(odometer);
        io.unobserve(en.target);
      });
    }, { threshold: 0.3 });
    items.forEach(function (el) { io.observe(el); });

    // Divider line sweep
    var lineIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('land-drawn'); lineIo.unobserve(en.target); }
      });
    }, { threshold: 0 });
    lineIo.observe(root);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["land-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-land-js="land-testimonials"]');
    if (!root) return;
    var els = root.querySelectorAll('[data-land-reveal]');
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('land-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('land-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.2 });
    els.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();
})();
